import Public from '@/views/public'
import Painel from '@/views/public/painel'
import Assistencia from '@/views/public/assistencia'
import AssistenciaDetalhes from '@/views/public/assistencia/Detalhes'
import Dados from '@/views/public/dados'
import DadosSecretaria from '@/views/public/dados/PorSecretaria'
import DadosDetails from '@/views/public/dados/details'
import DadosComapare from '@/views/public/dados/compare'
import Escalas from '@/views/public/escalas'
import Escolas from '@/views/public/educacao/dashboard'
import DetalhesEscolas from '@/views/public/educacao/detalhes'
import PlanosMunicipal from '@/views/public/planos_municipal'
import PDM from '@/views/public/pdm'
import PDG from '@/views/public/pdg'
import Favoritos from '@/views/public/favoritos'
import Pesquisa from '@/views/public/pesquisa'
import Materiais from '@/views/public/materiais'
import DividaAtiva from '@/views/public/divida_ativa'
import Manutencao from '@/views/public/manutencao'

import {
  prestacoes,
  concursos,
  receitasDespesas,
  consumo,
  remedios,
  emendasParlamentares,
  procedimentosSaude,
  eleicaoConselho,
  movimentosODS,
  planoDeGoverno
} from './public/'
import { DEFAULT_TITLE } from './const'

const routes = [
  {
    path: '/',
    component: Public,
    children: [
      {
        path: '/',
        component: Painel
      },
      {
        path: '/pesquisa/volta_aulas',
        name: 'volta_aulas',
        component: Pesquisa,
        meta: {
          title: `${DEFAULT_TITLE} | Pesquisa volta as aulas`
        }
      },
      {
        path: '/assistencia',
        name: 'beneficios_auxilios',
        component: Assistencia,
        meta: {
          title: `${DEFAULT_TITLE} | Benefícios Assistenciais`
        }
      },
      {
        path: '/assistencia/detalhes/:sigla',
        name: 'beneficios_detalhes',
        component: AssistenciaDetalhes,
        meta: {
          title: `${DEFAULT_TITLE} | Beneficiados por programa`
        }
      },
      {
        path: '/favoritos',
        name: 'favoritos',
        component: Favoritos,
        meta: {
          title: `${DEFAULT_TITLE} | Favoritos`
        }
      },
      {
        name: 'public_detalhes',
        path: '/detalhes/:id',
        component: DadosDetails,
        meta: {
          title: `${DEFAULT_TITLE} | Detalhes do dado`
        }
      },
      {
        name: 'public_comparar',
        path: '/comparar/:ids',
        component: DadosComapare,
        meta: {
          title: `${DEFAULT_TITLE} | Comparar dados`
        }
      },
      {
        path: '/listar/dados',
        name: 'listar_dados',
        component: Dados,
        meta: {
          title: `${DEFAULT_TITLE} | Lista de dados`
        }
      },
      {
        path: '/listar/dados-secretaria',
        name: 'listar_dados_secretaria',
        component: DadosSecretaria,
        meta: {
          title: `${DEFAULT_TITLE} | Lista de dados por Secretaria`
        }
      },
      {
        path: '/escalas',
        name: 'escalas',
        component: Escalas,
        meta: {
          title: `${DEFAULT_TITLE} | Escalas de Plantão`
        }
      },
      // {
      //   path: '/educacao',
      //   name: 'educacao',
      //   component: Escolas,
      //   meta: {
      //     title: `${DEFAULT_TITLE} | Educação Transparente`
      //   }
      // },
      // {
      //   name: 'dados_escola',
      //   path: '/educacao/detalhes',
      //   component: DetalhesEscolas,
      //   meta: {
      //     title: `${DEFAULT_TITLE} | Detalhes por escola`
      //   }
      // },
      {
        name: 'planosmunicipal',
        path: '/planosmunicipal',
        component: PlanosMunicipal,
        meta: {
          title: `${DEFAULT_TITLE} | Planos Municipal`
        }
      },
      {
        name: 'planometas',
        path: '/planometas',
        component: PDM,
        meta: {
          title: `${DEFAULT_TITLE} | Plano de Metas`
        }
      },
      {
        name: 'planogoverno',
        path: '/planogoverno',
        component: PDG,
        meta: {
          title: `${DEFAULT_TITLE} | Plano de Governo`
        }
      },
      {
        path: '/materiais',
        name: 'materiais',
        component: Materiais,
        meta: {
          title: `${DEFAULT_TITLE} | Materiais Padronizados`
        }
      },
      {
        path: '/divida-ativa',
        name: 'divida-ativa',
        component: DividaAtiva,
        meta: {
          title: `${DEFAULT_TITLE} | Dívida Ativa`
        }
      },
      {
        path: '/manutencao',
        name: 'manutencao',
        component: Manutencao,
        meta: {
          title: `${DEFAULT_TITLE} | Em Manutenção`
        }
      },
      ...receitasDespesas,
      ...concursos,
      ...prestacoes,
      ...consumo,
      ...remedios,
      ...procedimentosSaude,
      ...emendasParlamentares,
      ...eleicaoConselho,
      ...movimentosODS,
      ...planoDeGoverno
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/public.js